import { useMutation } from '@apollo/client';
import { DespatchAdviceSource } from '@common/enums';
import { useCallback } from 'react';

import * as beastQueries from '~/@store/beastIntegration/beastIntegration.queries';
import { DeliveryLineRestoreMutation, DeliveryLineRestoreMutationVariables } from '~/graphql';
import { handleApolloError } from '~/utils';

import * as queries from '../deliveryLines.queries';
import { deliveryLinesStore } from '../deliveryLines.store';
import type { IDeliveryLine } from '../deliveryLines.types';

type DeleteDeliveryLineFunc = () => Promise<unknown>;

export const useDeliveryLineRestoreMutation = (deliveryLine: IDeliveryLine): [DeleteDeliveryLineFunc, boolean] => {
    const [callMutation, mutationResult] = useMutation<
        DeliveryLineRestoreMutation,
        DeliveryLineRestoreMutationVariables
    >(queries.DeliveryLineRestoreMutation);

    const restoreDeliveryLine = useCallback<DeleteDeliveryLineFunc>(() => {
        return callMutation({
            variables: { id: deliveryLine.id },
            refetchQueries: [
                {
                    query: queries.AdminDeliveryLinesPagedQuery,
                    variables: deliveryLinesStore.deliveryLinesQueryVariables,
                },
                {
                    query: beastQueries.AdminBeastDataQuery,
                    variables: {
                        entityId: deliveryLine.id,
                        source: DespatchAdviceSource.DELIVERY_LINE,
                    },
                },
            ],
        }).catch(handleApolloError);
    }, [deliveryLine, callMutation]);

    return [restoreDeliveryLine, mutationResult.loading];
};
